import type { HouseSlug, Locale } from 'lc-services/types'

export const useSearchDestination = () => {
  const { locale } = useI18n<unknown, Locale>()
  const {
    allDestinations,
    destinations,
    fetchAllDestinations,
    fetchDestinationsAndHouses,
  } = useSearchInput()

  const toOptions = (item: {
    id: string | number
    name: string | HouseSlug
  }) => ({
    label: typeof item.name === 'string' ? item.name : item.name[locale.value],
    value: String(item.id),
  })

  const destinationOptions = async (query: string | null) => {
    try {
      if (!query || query.length < 2) {
        if (!allDestinations.value.length) await fetchAllDestinations()
        return allDestinations.value.map(toOptions)
      }
      await fetchDestinationsAndHouses(query)
      return destinations.value.map(toOptions)
    } catch {
      return []
    }
  }

  return { destinationOptions }
}
